module.exports = __webpack_public_path__ + "img/sutherapy_04.56952816.jpg";